<div class="center{{!readonly && !disabled?'-sm':''}}">
    <div class="cursor-pointer text-overflow" [class._input]="!readonly && !disabled" *ngIf="!focus"><span class="text-overflow">{{value}}</span></div>
    <input #input type="text" [value]="value" placeholder="Aa..." *ngIf="focus" (blur)="setFocus(false)" (change)="emitValue(input.value || ''); setFocus(false)">
</div>